import React, { useRef, useEffect } from 'react';
import 'twin.macro';
import { Small, TextLine } from '../text';
import { Input } from '.';

const MIN_YEAR = 1900;
const MAX_YEAR = new Date().getFullYear() - 1;

const isValidRange = (num, min, max) => num >= min && num <= max;

export const isWrongDay = (day) => day.length === 2 && !isValidRange(Number(day), 1, 31);
export const isWrongMonth = (month) => month.length === 2 && !isValidRange(Number(month), 1, 12);
export const isWrongYear = (year) =>
  year.length === 4 && !isValidRange(Number(year), MIN_YEAR, MAX_YEAR);

const addLeadingZero = (input) => (input.length === 1 ? '0' + input : input);

export const DateInput = ({ birthDate, setBirthdate, showDateFormatLabel = true }) => {
  const { day, month, year } = birthDate;
  const monthInputRef = useRef();
  const yearInputRef = useRef();

  const INVALID_DATE = 'Dag moet tussen 1 en 31 liggen';
  const INVALID_MONTH = 'Maand moet tussen 1 en 12 liggen';
  const INVALID_YEAR = `Jaar moet tussen ${MIN_YEAR} en ${MAX_YEAR} liggen`;

  const handleInputChange = (key, value) => {
    if (!/^\d*$/.test(value)) return; // Prevent non-numeric input
    if (value.length > (key === 'year' ? 4 : 2)) return; // Limit length

    setBirthdate({ ...birthDate, [key]: value });
  };

  // Move focus when a valid 2-digit day or month is entered
  useEffect(() => {
    if (day.length === 2 && isValidRange(Number(day), 1, 31)) {
      monthInputRef.current?.focus();
    }
  }, [day]);

  useEffect(() => {
    if (month.length === 2 && isValidRange(Number(month), 1, 12)) {
      yearInputRef.current?.focus();
    }
  }, [month]);

  return (
    <>
      {showDateFormatLabel && <Small tw='font-bold'>Geboortedatum (dd/mm/yyyy)</Small>}
      <div tw='flex gap-4 mt-2'>
        <Input
          label='Dag'
          placeholder='Dag'
          id='register-day'
          value={day}
          maxLength='2'
          requiredField
          hasInlineAsterisk
          pattern='[0-9]*'
          type='number'
          onChange={(e) => handleInputChange('day', e.target.value)}
          onBlur={(e) =>
            e.target.value.length === 1 &&
            setBirthdate({ ...birthDate, day: addLeadingZero(e.target.value) })
          }
        />
        <Input
          label='Maand'
          placeholder='Maand'
          id='register-month'
          value={month}
          maxLength='2'
          requiredField
          ref={monthInputRef}
          hasInlineAsterisk
          pattern='[0-9]*'
          type='number'
          onChange={(e) => handleInputChange('month', e.target.value)}
          onBlur={(e) =>
            e.target.value.length === 1 &&
            setBirthdate({ ...birthDate, month: addLeadingZero(e.target.value) })
          }
        />
        <Input
          label='Jaar'
          placeholder='Jaar'
          id='register-year'
          value={year}
          maxLength='4'
          requiredField
          ref={yearInputRef}
          hasInlineAsterisk
          pattern='[0-9]*'
          type='number'
          onChange={(e) => handleInputChange('year', e.target.value)}
        />
      </div>
      {(isWrongDay(day) || isWrongMonth(month) || isWrongYear(year)) && (
        <ul tw='flex flex-col mb-4'>
          {isWrongDay(day) && (
            <li>
              <TextLine small text={INVALID_DATE} tw='text-danger block' />
            </li>
          )}
          {isWrongMonth(month) && (
            <li>
              <TextLine small text={INVALID_MONTH} tw='text-danger block' />
            </li>
          )}
          {isWrongYear(year) && (
            <li>
              <TextLine small text={INVALID_YEAR} tw='text-danger block' />
            </li>
          )}
        </ul>
      )}
    </>
  );
};
